import { OverlayRef } from '@angular/cdk/overlay';
import { BehaviorSubject } from 'rxjs';

export class ToastRef {
  private object = new BehaviorSubject<any | null>(null);

  constructor(private overlay: OverlayRef) {}

  close() {
    this.overlay.dispose();
    this.object.complete();
  }

  click(data: unknown) {
    this.object.next(data);
    this.close();
  }

  getPosition() {
    return this.overlay.overlayElement.getBoundingClientRect();
  }

  isVisible() {
    return this.overlay && this.overlay.overlayElement;
  }

  afterClicked() {
    return this.object.asObservable();
  }
}
